var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var DOMPurify = require('dompurify');
import constants from '../constants';
import {
        createErrorNotification,
        updateCartTotals,
        validateBasket,
        updateApproachingDiscounts,
        handlePromotionCodeError,
        updateProductImage,
        resetPromotionCodeError,
        updateCartComponents
} from './cartCustomService';
var utils = require('../utils');


export default class PromoCode {

    // initialized on load
    constructor() {
        this.onLoadPromoCode();
        this.onChangePromoCode();
        this.onApplyPromoCode();
        this.onRemoveCouponCode();
    }

    updatePaymentState(data) {
        let checkooutStage = document.getElementsByClassName('data-checkout-stage');
        if (checkooutStage.length && (checkooutStage[0].getAttribute('data-checkout-stage') === 'payment' || checkooutStage[0].getAttribute('data-checkout-stage') === 'shipping')) {
            var summaryHelpers = require('../checkout/summary');
            summaryHelpers.updateTotals(data.totals);
        }
    }

    initializePaymentIfPaymentPage() {
        let checkooutStage = document.getElementsByClassName('data-checkout-stage');
        if (checkooutStage.length && checkooutStage[0].getAttribute('data-checkout-stage') === 'payment') {
            var adyenCheckout = require('adyen_custom/adyen/checkout');
            adyenCheckout.init();
        }
    }

    onLoadPromoCode() {
        var self = this;
        $(function () {
            const id = $('.coupon-price-adjustment').data('uuid');
            const $promoCodeAccordion = $('.promotion-code .promotion-code--btn-toggle');
            const promoCode = $('.promotion-code--btn-toggle').attr('data-promo');
            const $promoForm = $('.promotion-code__formdata');

            if (id) {
                const code = $('.remove-coupon').data('code');
                const errorMessage = $('.coupon-promotion-message').val() ? $('.coupon-promotion-message').val() : $('.coupon-not-applied').text();
                const errorMessageDetailModalInfo = $('.coupon-promotion-details').val();

                if (code) {
                    $promoForm.addClass('has-promo');
                    $('.applied-promo-code').text(code);
                } else {
                    $promoForm.removeClass('has-promo');
                }

                if (errorMessage) {
                    handlePromotionCodeError({
                        errorMessage,
                        errorMessageDetailModalInfo
                    });
                }

                if (code && promoCode) {
                    $promoForm.removeClass('d-none');
                    $promoCodeAccordion.trigger('click', true);
                }

                return;
            }

            if (promoCode === 'true') {
                $promoCodeAccordion.trigger('click', true);
                return;
            }

            return;
        });

        $('.promotion-code--btn-toggle').on('click', function (e) {
            const inputElement = document.getElementById('fakeFocusInput');
            // only trigger focus if accordion is open
            if ($(this).hasClass('collapsed')) {
                inputElement.style.visibility = 'visible'; // unhide the input
                inputElement.focus(); // focus on it so keyboard pops
                inputElement.style.visibility = 'hidden'; // hide it again
            }

            // Temp fix for multiple bootstrap triggers on cart page
            if ($('.promotion-code--item').hasClass('show') && $('.page.current.cart').length) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $('.promotion-code--item').collapse('hide');
                $('.promotion-code--btn-toggle').addClass('collapsed');
            }
        });

        $('#promotion-content').on('show.bs.collapse', (e) => {
            if ($(e.target).hasClass('promotion-code--item')) {
                const promoCode = $('.promotion-code--btn-toggle').attr('data-promo');
                // if Promocode is collapsible by default then promoInputfeild shouldn't be in focus
                if (promoCode === 'true') {
                    $('.promotion-code--btn-toggle').attr('data-promo', false);
                    return;
                }
                setTimeout(() => $('#couponCode').trigger('focus'), 0);
            }
        });

        $('body').on(constants.events.COUPON_REMOVED, function (e, _data) {
            e.preventDefault();
            $('.couponCode').val('');
            $('#couponCode').attr('readonly', false);
            resetPromotionCodeError();
            var url = _data.Url;
            var urlParams = {
                code: _data.couponCode,
                uuid: _data.uuid
            };
            var checkoutWrapper = $('#checkout-wrapper');
            if (checkoutWrapper.length) {
                urlParams.pageType = checkoutWrapper.attr('data-pageType');
            }
            url = utils.appendToUrl(url, urlParams);

            $.spinner().start();
            $('body').trigger(constants.events.PROMOTION_BEFORE_UPDATE);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    var cartProductList = $('.js-product--list');
                    $('.coupon-uuid-' + urlParams.uuid).remove();
                    if (cartProductList.length) {
                        if (data.items.length) {
                            cartProductList.html(data.renderTemplate);
                        } else {
                            const $targetContainer = $('.emptycart-ooslist');
                            $targetContainer.html(data.renderTemplate);
                            const $cartPage = $('.cart');
                            $cartPage.removeClass('has-cart-items, cart-page');
                            $('.shipping--intro').addClass('d-none');
                            $cartPage.addClass('cart-empty');
                        }
                        updateCartComponents(data);
                    }
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    self.updatePaymentState(data);
                    self.initializePaymentIfPaymentPage();
                    if (cartProductList.length) {
                        cartProductList.html(data.renderTemplate);
                    } else {
                        $('.order-summary__container').empty().append(data.renderTemplate);
                    }
                    updateProductImage(data);
                    // Antavo Loyalty start
                    if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                        $('.tooltip-wrapper .tooltip-points').empty().append('Members earn points ' + data.antavoRewardPoints.points + ' Preferred Loyalty points on this purchase.');
                        $('.loyalty-info-message-points').val(data.antavoRewardPoints.points);
                        $('.reward-earned-payment').html(data.antavoRewardPoints.points);
                        $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                        $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                        if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                            $('.loyalty-info-message .checkout-loyaltyrewards-container').removeClass('hide-antavo-copy');
                        }
                        if (data.antavoRewardPoints.points === 0) {
                            $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                            if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                $('.loyalty-info-message .checkout-loyaltyrewards-container').addClass('hide-antavo-copy');
                            }
                        }
                    }
                    $.spinner().stop();
                    $('body').trigger(constants.events.PROMOTION_SUCCESS, data);
                    $('#couponCode').trigger('focus');
                },
                error: function (err) {
                    $('body').trigger(constants.events.PROMOTION_ERROR, err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        utils.createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                    tealiumEnable.getAnalyticsData('serverError', err.responseJSON.errorCode);
                    tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                }
            });
        });
    }

    onChangePromoCode() {
        $('.couponCode').on('input', function () {
            $('.promotion-code__formdata .promo-code-box').removeClass('is-error');
            $('.promo-code-box-label').removeClass('is-error');
            $('.promotion-code--error').addClass('d-none');
            return;
        });
    }

    handleCouponCodeError() {
        var $errorMessage = $('.promotion-code--error');
        $errorMessage.removeClass('d-none');
        $('.code-error-message').empty().append(DOMPurify.sanitize($errorMessage.attr('data-missing')));
        $('.promotion-code__formdata .promo-code-box').addClass('is-error');
        $('.promo-code-box-label').addClass('is-error');
    }

    resetPromocodeForm() {
        $('.applied-promo-code').empty();
        $('.promotion-code--header').removeClass('disabled');
        $('.promotion-code--header').addClass('enabled');
        $('.promo-code-box-label').removeClass('is-error');
        $('.promotion-code__formdata').removeClass('has-promo');
    }

    onApplyPromoCode() {
        var self = this;
        $('.promotion-code__formdata').on('submit', function (e) {
            e.preventDefault();
            $.spinner().start();
            var pageType = $('.page').data('page') || 'cart';
            var couponCode = $("input[id='couponCode']", this).val(); // eslint-disable-line
            if (/\s/.test(couponCode)) {
                couponCode = couponCode.trim();
                this.querySelector('#couponCode').value = couponCode;
            }
            const $form = $(this);
            if (!couponCode) {
                self.handleCouponCodeError();
                $.spinner().stop();
                return false;
            }
            $('body').trigger('promotion:beforeUpdate');
            // make sure promo code section is always expanded when promo code is applied
            if (!$('.promotion-code--item').hasClass('show')) {
                $('.promotion-code--item').addClass('show');
            }
            $.ajax({
                url: $form.attr('action'),
                type: 'GET',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data.error) {
                        let $promoInput = $('.promotion-code__formdata .promo-code-box');
                        if ($promoInput.length && !$promoInput.val().length) {
                            handlePromotionCodeError({
                                ...data,
                                errorMessageDetailModalInfo: ''
                            }, true);
                        } else {
                            handlePromotionCodeError({
                                ...data,
                                errorMessageDetailModalInfo: ''
                            });
                        }
                        tealiumEnable.getAnalyticsData('serverError', data.errorCode);
                        tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                        $('body').trigger('promotion:error', data);
                    } else {
                        if ($('.js-product--list').length) {
                            if (data.items.length) {
                                $('.js-product--list').html(data.renderTemplate);
                            } else {
                                const $targetContainer = $('.emptycart-ooslist');
                                $targetContainer.html(data.renderTemplate);
                                const $cartPage = $('.cart');
                                $cartPage.removeClass('has-cart-items, cart-page');
                                $('.shipping--intro').addClass('d-none');
                                $cartPage.addClass('cart-empty');
                            }
                            updateCartComponents(data);
                        }
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        self.updatePaymentState(data);
                        self.initializePaymentIfPaymentPage();
                        $('body').trigger('promotion:success', data);
                        $('.cart-header__description').attr('data-tealiumitemquantity', data.numItems);
                        $('.order-level-discount-section').removeClass('d-none');
                        $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.cartAnalyticsData, priceAndSize: data.checkoutAnalyticsPriceAndSize });
                        tealiumEnable.getAnalyticsData('applyCoupon', data, couponCode);
                        tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                        $('.outofstock_checkout_error').addClass('d-none');
                        // Antavo Loyalty start
                        if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                            $('.tooltip-wrapper .tooltip-points').empty().append('Members earn points ' + data.antavoRewardPoints.points + ' Preferred Loyalty points on this purchase.');
                            $('.loyalty-info-message-points').val(data.antavoRewardPoints.points);
                            $('.reward-earned-payment').html(data.antavoRewardPoints.points);
                            $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                            $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                            if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                $('.loyalty-info-message .checkout-loyaltyrewards-container').removeClass('hide-antavo-copy');
                            }
                            if (data.antavoRewardPoints.points === 0) {
                                $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                                if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                    $('.loyalty-info-message .checkout-loyaltyrewards-container').addClass('hide-antavo-copy');
                                }
                            }
                        }
                    }
                    if ($('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    if ($('.rewards-redeem-error').length) {
                        $('.rewards-redeem-error').remove();
                    }
                    if (pageType === 'cart') {
                        utils.uniformSpacing();
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    if ($('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    if ($('.rewards-redeem-error').length) {
                        $('.rewards-redeem-error').remove();
                    }
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                    if (pageType === 'cart') {
                        utils.uniformSpacing();
                    }
                }
            });
            return false;
        });
    }

    onRemoveCouponCode() {
        var self = this;
        $('body').on('click', '.removePromoCode', function (e) {
            e.preventDefault();
            let $removeCoupenButton = $('.remove-coupon');
            var pageType = $('.page').data('page') || 'cart';
            let data = {
                couponCode: $removeCoupenButton.data('code'),
                uuid: $removeCoupenButton.data('uuid'),
                Url: $(this).data('action')
            };
            self.resetPromocodeForm();
            $('body').trigger(constants.events.COUPON_REMOVED, data);
            $('.promotion-code__formdata').removeClass('d-none');
            $('.icon-add').toggleClass('d-none');
            $('.icon-remove').toggleClass('d-none');
            if ($('.rewards-redeem-error').length) {
                $('.rewards-redeem-error').remove();
            }
            $('.outofstock_checkout_error').addClass('d-none');
            if (pageType === 'cart') {
                if ($('.cart-errormsg-wrapper .cart-top-errors').length && !$('.cart-errormsg-wrapper .cart-top-errors').find('.promo-code-error').hasClass('d-none')) {
                    $('.cart-errormsg-wrapper .cart-top-errors').find('.promo-code-error').addClass('d-none');
                }

                utils.uniformSpacing();
            }
        });
    }
    // end of class
}
